import { IotaExtension } from '../../iota_applications/types';
import { ConnectionsDefinitionsResult, ConnectionsDefinition, ConnectionsDefinitionCreateModel } from '../types';
import appClient from '../../common/services/AppClient';
import { ResultApi } from '../../common/services/AppClient';
import { Utils } from '../../common/services/Utils';
import { endpoints } from '../../../config';

export default class ConnectionsDefinitionsService {
    async getAll(projectId?: string): Promise<ConnectionsDefinition[]> {
        if (!projectId) {
            throw new Error(
                'Global connection definition reads are not supported by ManageService. Provide a project id.'
            );
        }

        return this.getForProject(projectId);
    }

    async getForProject(projectId: string): Promise<ConnectionsDefinition[]> {
        const result = await appClient.get<ConnectionsDefinitionsResult['getConnectionsDefinitions']>(
            `${endpoints.manageUrl}projects/${projectId}/iota_connections`
        );
        if (result.isErr()) {
            console.log(result.error);
            throw result.error;
        }

        return result.value || [];
    }

    async get(projectId: string | null, id: string | null): Promise<ConnectionsDefinition | null> {
        if (!projectId || !id) {
            return null;
        }

        const result = await appClient.get<ConnectionsDefinition | null>(
            `${endpoints.manageUrl}projects/${projectId}/iota_connections/${id}`
        );
        if (result.isErr()) {
            console.log(result.error);
            throw result.error;
        }

        return result.value;
    }

    async getMetadata(): Promise<IotaExtension[]> {
        const url = endpoints.iotaUrl + 'metadata';
        const resp = await appClient.get<IotaExtension[]>(url);
        return resp.unwrapOr(Array<IotaExtension>());
    }

    async exportConnection(id: string, projectId: string) {
        return Utils.CreateTabForDownload(id, `projects/${projectId}/iota_connections/export`);
    }

    create(model: ConnectionsDefinitionCreateModel, projectId: string): Promise<ResultApi<string>> {
        const url = endpoints.manageUrl + `projects/${projectId}/iota_connections`;
        return appClient.post(url, model);
    }

    delete(id: string, projectId: string): Promise<ResultApi<unknown>> {
        const url = `${endpoints.manageUrl}projects/${projectId}/iota_connections/${id}`;
        return appClient.delete(url);
    }

    edit(formData: FormData, id: string, projectId: string): Promise<ResultApi<unknown>> {
        const url = `${endpoints.manageUrl}projects/${projectId}/iota_connections/${id}`;
        return appClient.post(url, formData);
    }

    updateSettings(id: string, settings: { [id: string]: unknown }, projectId: string): Promise<ResultApi<unknown>> {
        const request = {
            settingValues: settings
        };

        const url = `${endpoints.manageUrl}projects/${projectId}/iota_connections/${id}/settings`;
        return appClient.update(url, request);
    }

    executeConnection(projectId: string, definitionId: string, connectionId: string): Promise<ResultApi<JSON>> {
        const url = `${endpoints.manageUrl}projects/${projectId}/iota_connections/test/${definitionId}/${connectionId}`;
        const requestBody = {
            page: 0,
            pageSize: 10,
            connectionId: connectionId,
            fields: ['text', 'value'],
            filters: undefined
        };

        return appClient.post<JSON>(url, requestBody);
    }
}
